import React from 'react';

import './RecentSearches.scss';
import { motion, useReducedMotion } from 'framer-motion';

export interface IRecentSearchesProps {
  recentSearchTerms: string[];
  onSelect: (val: string) => void;
  onClear: (val: []) => void;
}

const RecentSearches = ({
  recentSearchTerms,
  onSelect,
  onClear,
}: IRecentSearchesProps) => {
  const yPos = useReducedMotion() ? 0 : 8;

  const handleSearchBarFocus = () => {
    const searchBar = document.querySelector('.search-bar__input');
    searchBar && (searchBar as HTMLElement).focus();
  };

  return (
    <motion.section
      className="recent-searches"
      initial={{ opacity: 0, y: yPos }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
    >
      <h3 className="recent-searches__title">Recent Searches</h3>
      <ul className="recent-searches__list">
        {recentSearchTerms.map((searchTerm: string, i: number) => (
          <li key={i} className="recent-searches__list-item">
            <button onClick={() => onSelect(searchTerm)}>{searchTerm}</button>
          </li>
        ))}
      </ul>
      <button
        onClick={() => {
          onClear([]);
          handleSearchBarFocus();
        }}
        className="recent-searches__button"
      >
        Clear Recent Searches
      </button>
    </motion.section>
  );
};

export default RecentSearches;
